<template>
  <div id="gwi-myPay" class="app my-app">
    <section class="thick">
      <hospital-select
          id="myPay-select-hospital"
          @selected="selectHospital"
      ></hospital-select>
      <voucher-select
          id="myPay-select-voucher"
          :list="voucherList"
          @selected="selectVoucher"
      ></voucher-select>
    </section>
    <div class="query-history" style="height: 32px">
      <div class="history-more">
        <div class="option" id="StartDate" @click="setStartDate">
          {{ startDate }}
        </div>
        <span></span>
        <div class="option" id="EndDate" @click="setEndDate">{{ endDate }}</div>
        <button class="btn-ok" @click="chooseNewDate()">确定</button>
      </div>
    </div>
   <scroll @refresh="refresh" id="my-pay-scroll" class="from-query-more">
      <section :id="'myPay-payItem-' + index" class="thick my-pay" v-for="(pay, index) in payList" :key="index" style="border-radius:8px;box-shadow: 0px 1px 5px #d7d7d7; margin: 0.5rem 0.2rem; padding: 0rem 0.25rem;">
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">项目名称</td>
            <td  class="item-value">{{ pay.itemName }}</td>
          </table>
        </div>
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">项目类型</td>
            <td  class="item-value">{{ pay.itemType }}</td>
          </table>
        </div>
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">总价</td>
            <td  class="item-fee-value">{{ pay.totalFee | formatFee }}</td>
          </table>
        </div>
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">费用时间</td>
            <td  class="item-value">{{ pay.operTime | formatpayDate }}</td>
          </table>
        </div>
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">规格</td>
            <td  class="item-value">{{ pay.note }}</td>
          </table>
        </div>
        <div class="my-item">
          <table class="item-table">
            <td class="item-name">数量</td>
            <td  class="item-value">{{ pay.qty }}</td>
          </table>
        </div>
          <div class="my-item" style=" border-bottom: 0px solid #e9e9e9;">
            <table class="item-table">
              <td class="item-name">单价</td>
              <td  class="item-fee-value">{{ pay.price | formatFee }}</td>
            </table>
          </div>
      </section>
      <no-record
          :condition="payList"
          :tips="'抱歉，没有住院清单记录！'"
      ></no-record>
    </scroll>
  </div>
</template>
<script>
import NoRecord from 'NoRecord'
import queryFun from 'queryFunList.service'
import queryVoucher from 'voucher.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import voucherService from 'voucher.service'
export default {
  components: {
    NoRecord,
    HospitalSelect,
    VoucherSelect
  },
  data () {
    return {
      payList: [],
      noRecord: false,
      voucher: {},
      voucherList: [],
      utils: this.$utils,
      startDate: '',
      endDate: ''
    };
  },
  created () {
    //判断是否存在tokenId,且当前界面code失效
    var query = this.$router.currentRoute.query
    var code = query.code
    if (code) {
      var getTokenParams = { code: code }
      voucherService.getToken(getTokenParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          //查询该用户未使用过该公众号
          this.loadVouchers()
          return
        }
        //缓存最新code给后台
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
        //返回新token保存本地使用
        localStorage.tokenId = res.data.tokenId;
        localStorage.setItem('tokenId', res.data.tokenId);
        sessionStorage.setItem('tokenId', res.data.tokenId);
        window.http.headers.common['tokenId'] = localStorage.tokenId || ''
        window.http.headers.common['deviceId'] = localStorage.deviceId || ''
        this.loadVouchers()
      })
    } else {
      this.loadVouchers()
    }
  },
  methods: {
    refresh () {
      this.loadMore()
      if (!this.voucher.cardType || !this.voucher.cardNo) {
        this.$utils.alert('请先绑定诊疗卡');
        return;
      }
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        startDate : this.startDate,
        endDate :this.endDate,
      };
      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) === "undefined") {
        this.$utils.alert("请选择医院");
        return;
      }
      this.loadMyPayList(params);
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'HospitalCostList',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    selectHospital () {
      this.payList = this.constant.ARRAY_CLEAN;
      this.refresh();
    },
    selectVoucher (v) {
      this.payList = this.constant.ARRAY_CLEAN;
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'HospitalCostList',
        voucher: v
      });
      //加载默认卡的待缴费列表
      this.refresh();
    },
    loadMyPayList (params) {
      queryFun.getCostList(params).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.payList = []
          return;
        }
        this.payList = res.data.rows || [];
      });
    },
    //默认初始化日历控件
    formatDatePicker () {
      var dateOb = new Date()
      var year = dateOb.getFullYear()
      var month = dateOb.getMonth()
      var day = dateOb.getDate()
      var lastDay = new Date(year, month, day);
      var lastStartDate = new Date(year, month, day-7);
      this.startDate = lastStartDate.format('yyyy-MM-dd')
      this.endDate = lastDay.format('yyyy-MM-dd')
    },
    //判断日期是否合法
    checkDate (sDate, eDate) {
      var formate = new RegExp(/-/g);
      sDate = sDate.replace(formate, "");
      eDate = eDate.replace(formate, "");
      //判断日期大小及合法性
      if ((sDate > eDate) || (sDate === '') || (eDate === '')) {
        this.$utils.alert('日期输入格式不正确，请重新输入');
        return false
      }
      return true
    },
    /* eslint-disable */
    loadMore () {
        $("#my-pay-scroll").addClass("include-date-scroll")
        $("#my-pay-scroll").removeClass("from-query-more")
        $("#my-pay-scroll").removeClass("scroll")
      //初始化日期控件
      this.formatDatePicker();
    },
    setStartDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.startDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.startDate = newDate.format('yyyy-MM-dd')
        }
      });
    },
    setEndDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.endDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.endDate = newDate.format('yyyy-MM-dd')
        },
      })
    },
    chooseNewDate () {
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo
      };
      if (this.checkDate(this.startDate, this.endDate)) {
        params.startDate = this.startDate
        params.endDate = this.endDate
        this.loadMyPayList(params)
      }
    }
  },
  watch: {
    payList (val) {
      this.noRecord = val.length === 0;
    }
  }
}
</script>
<style lang="scss">
.my-app {
  background-color: #eff2f5;
  .my-pay {
    .panel {
      height: 1rem;
      line-height: 1rem;
    }
    .table-row {
      height: 1.5rem;
      padding: 0.3rem 0.3rem;
      border-bottom: none;
    }
    .mycol {
      padding-right: 23px;
      text-align: right;
      .f-strongest {
        color: #ff0101;
      }
    }
  }
}
.my-item {
  border-bottom: 1px solid #e9e9e9;
  height: 35px;
  line-height:35px;
  .item-table{
    width:100%;
  }
  .item-name {
    color: #999999;
    width: 20%;
  }
  .item-value {
    text-align: right;
    width: 80%;
  }
  .item-fee-value {
    text-align: right;
    width: 80%;
    color: #ff0101;
  }
}
</style>



// WEBPACK FOOTER //
// inpatientCostList.vue?51e647fa